<template>
<div class="wrap">
    <div id="js-loader" class="loader">
        <img class="loader__03" src="/img/load03.png" width="180" height="150">
        <img class="loader__02" src="/img/load02.png" width="180" height="150">
        <img class="loader__01" src="/img/load01.png" width="180" height="150">
    </div>
    <p>MFJ設立後60年の歩みを『MFJライディング』（MFJが2012年まで機関誌として発行）と共に振り返ります。<br>年をクリックする事でその年の出来事と、MFJ ライディングが表示されます。</p>
    <div class="history">
        <button class="history__head" @click="toggle('60')"><span class="history__head--circle">1961-1970</span></button>
        <div class="history__content">  
            <div class="history__content--box" v-for="child of limitCount60" :key="child.id">
                <yearBox :year=child.id :caption=child.cap />
            </div>
        </div>
    </div>
    <div class="history">
        <button class="history__head" @click="toggle('70')"><span class="history__head--circle">1971-1980</span></button>
        <div class="history__content">  
            <div class="history__content--box" v-for="child of limitCount70" :key="child.id">
                <yearBox :year=child.id :caption=child.cap />
            </div>
        </div>
    </div>
    <div class="history">
        <button class="history__head" @click="toggle('80')"><span class="history__head--circle">1981-1990</span></button>
        <div class="history__content">  
            <div class="history__content--box" v-for="child of limitCount80" :key="child.id">
                <yearBox :year=child.id :caption=child.cap />
            </div>
        </div>
    </div>
    <div class="history">
        <button class="history__head" @click="toggle('90')"><span class="history__head--circle">1991-2000</span></button>
        <div class="history__content">  
            <div class="history__content--box" v-for="child of limitCount90" :key="child.id">
                <yearBox :year=child.id :caption=child.cap />
            </div>
        </div>
    </div>
    <div class="history">
        <button class="history__head" @click="toggle('00')"><span class="history__head--circle">2001-2010</span></button>
        <div class="history__content">  
            <div class="history__content--box" v-for="child of limitCount00" :key="child.id">
                <yearBox :year=child.id :caption=child.cap />
            </div>
        </div>
    </div>
    <div class="history">
        <button class="history__head" @click="toggle('10')"><span class="history__head--circle">2011-2021</span></button>
        <div class="history__content">  
            <div class="history__content--box" v-for="child of limitCount10" :key="child.id">
                <yearBox :year=child.id :caption=child.cap />
            </div>
        </div>
    </div>
    <p>※本サイト内のMFJライディング誌を含む、写真、画像、文章、その他すべてのコンテンツは、MFJの許可なく転載、二次使用することを禁止します。</p>
</div>
</template>

<script>
    import items from '@/assets/data.json'
    import Mixin from '@/mixins/mixin.js'
    import yearBox from '@/components/yearBox'
    export default {
        data: function() {
            return {
                show_contents: ['60'], //年代の初期表示
                childs: [
                    { id:1961, cap:'<li>日本モーターサイクルレース協会の名称で設立。同年、ＦＩＭへ加盟。</li><li>高橋国光選手が世界GPで日本人初優勝（5月・西ドイツGP）</li>'  },
                    { id:1962, cap:'<li>鈴鹿サーキットがオープン</li><li>第1回全日本ロードレース開催（鈴鹿サーキット）</li>' },
                    { id:1963, cap:'<li>日本モーターサイクル協会に名称変更</li><li>世界選手権ロードレース開催（鈴鹿サーキット［1966年］）</li><li>マン島TTレースで伊藤光夫選手が日本人初優勝</li><li>機関誌『MFJライディング』創刊</li>' },
                    { id:1964, cap:'<li>第1回モトクロス日本グランプリ開催（相馬が原）</li>' },
                    { id:1965, cap:'<li>久保和夫、鈴木誠一両選手が日本人として初めて世界GPモトクロスに出場</li><li>富士スピードウェイがオープン</li>' },
                    { id:1966, cap:'<li>第1回最優秀(MVP)選手として、第３回モトクロス日本GP大会アマチュアクラスで優秀な成績を修めた三谷正次選手をヨーロッパへ派遣。ロードレースでは三室恵義、滋野靖穂両選手に決定</li><li>第４回世界選手権日本GPを富士スピードウェイで開催。</li><li>ホンダ、世界選手権ロードレース全クラスでメーカータイトルを獲得。</li>' },
                    { id:1967, cap:'<li>MFJ国内競技規則を確立</li><li>ロードレース全日本選手権シリーズ開始</li><li>モトクロス全日本選手権シリーズ開始</li>' },
                    { id:1968, cap:'<li>MFJ新基本方針を発表。「レースをアマチュアの手に戻す」と宣言</li><li>ベルギーGPで国産モトクロッサー初のGP優勝（スズキRH68・O.ペテルソン）</li>' },
                    { id:1969, cap:'<li>モトクロスが一大ブームとなりテレビ放映が相次ぐ</li>' },
                    { id:1970, cap:'<li>第1回全日本ジムカーナ大会を開催</li><li>筑波サーキットがオープン</li>' },
                    { id:1971, cap:'<li>スノーモビル全日本選手権シリーズ開始</li>' },
                    { id:1972, cap:'<li>国内競技規則、車両規則を大幅改訂。スポーツ専用市販車の使用を認める。</li><li>モトクロスに騒音規制を実施</li><li>トライアル委員会を設置</li>' },
                    { id:1973, cap:'<li>第1回トライアル全日本選手権大会を神奈川県早戸川で開催。</li>' },
                    { id:1974, cap:'<li>SSDT（スコティッシュ6日間トライアル）で日本車が初優勝（ヤマハ・M.アンドリュース）</li>' },
                    { id:1975, cap:'<li>スポーツランドSUGOオープン</li>' },
                    { id:1976, cap:'<li>トライアルの減点法に1/2/3/5点式を採用。</li>' },
                    { id:1977, cap:'<li>MFJ中央スポーツ委員会、モトクロス委員会を新設</li><li>片山敬済選手、ロードレース世界選手権ＧＰ350クラスチャンピオン獲得</li>' },
                    { id:1978, cap:'<li>渡辺明選手、モトクロス世界選手権125ccクラスチャンピオン獲得</li><li>第1回鈴鹿8時間耐久ロードレース大会が鈴鹿サーキットで開催</li><li>ロードレース日本GPで初の女性だけのレース「パウダー・パフ」を開催</li>' },
                    { id:1979, cap:'<li>MFJ［10万人キャンペーン］で世界選手権レース観戦招待などを実施。</li><li>MFJ会員へのサービス活動活発化を期し「MFJ活動協賛サークル」制度を創設。</li>' },
                    { id:1980, cap:'<li>世界耐久選手権鈴鹿8時間耐久ロードレース開催</li><li>［ミニバイク競技規則指導要綱］を作成</li><li>西日本サーキットがMFJ公認サーキットに。</li>' },
                    { id:1981, cap:'<li>FＩＭ総会を東京で開催</li>' },
                    { id:1982, cap:'<li>トライアル国際B級クラスを創設。</li><li>第19回モトクロス日本GPに高松宮宣仁親王がご来臨。</li><li>後楽園球場で日本初のスタジアムスーパークロス開催</li>' },
                    { id:1983, cap:'<li>ピットクルーライセンスを制定。</li><li>東京多摩テックでスタジアムトライアルを初開催。</li>' },
                    { id:1984, cap:'' },
                    { id:1985, cap:'<li>MFJ25周年に向け、記念シンボルマークを募集。</li>' },
                    { id:1986, cap:'<li>創立25周年。</li><li>県モーターサイクルスポーツ協会(県協会）を設立、MFJスポーツ協力店制度始まる。</li>' },
                    { id:1987, cap:'<li>創立25周年記念式典を開催。</li><li>世界選手権ロードレース開催を再開（鈴鹿サーキット）。</li><li>TTF-1/スーパーバイク世界選手権をスポーツランドSUGOで開催。</li><li>全日本モトクロス選手権に前・後期の二期制を導入。</li><li>トライアル・デ・ナイオンに初めて日本代表チームを派遣（伊藤敦志・山本昌也・中川義博）。8位入賞。</li>' },
                    { id:1988, cap:'<li>第1回MFJミニバイクグランドチャンピオン大会を開催（静岡県つま恋カートコース）。</li><li>杉沼浩MFJ常務理事が日本人として初めてマン島TTレースの審査委員長を務める。</li><li>第1回トライアル・ジュニアグランドチャンピオン大会を愛知県・キョウセイ交通大学で開催。</li>' },
                    { id:1989, cap:'<li>ライダーの親睦を図る［白馬ツーリング」を主催。</li><li>第1回ロードレースジュニアグランプリを開催(筑波サーキット）</li>' },
                    { id:1990, cap:'<li>MFJカップロードレース選手権シリーズが開始。</li><li>モトクロス・デ・ナシオンに日本代表チーム(東福寺保雄・岡部篤史・宮内隆行）を派遣。15位となる。</li>' },
                    { id:1991, cap:'<li>文部省（現文部科学省）所管の財団法人として認可。組織名を「財団法人日本モーターサイクルスポーツ協会（ＭＦＪ）」とする。</li><li>モトクロス世界選手権開催（鈴鹿サーキット）。</li><li>パンパシフィックロードレース、スーパーバイク選手権シリーズがスタート。</li><li>スタジアムトライアル全日本選手権シリーズ開始［〜1993］</li>' },
                    { id:1992, cap:'<li>ミニロードレース部会を設立。GP80クラスなどが各地で開催される。</li><li>第1回全日本バイクキャンプ大会を主催</li>' },
                    { id:1993, cap:'<li>ドラッグレース全日本選手権シリーズ開始［〜2008］。</li><li>原田哲也、ロードレース世界選手権ＧＰ250クラスチャンピオン獲得。</li>' },
                    { id:1994, cap:'<li>坂田和人、ロードレース世界選手権ＧＰ125クラスチャンピオン獲得。</li><li>スーパークロス全日本選手権シリーズ開始（〜1997）</li>' },
                    { id:1995, cap:'<li>青木治親、ロードレース世界選手権ＧＰ125クラスチャンピオン獲得。</li>' },
                    { id:1996, cap:'<li>青木治親、ロードレース世界選手権ＧＰ125クラスチャンピオン獲得。</li>' },
                    { id:1997, cap:'<li>全日本トライアル選手権に国際A級スーパークラスを設定。</li>' },
                    { id:1998, cap:'<li>坂田和人、ロードレース世界選手権ＧＰ125クラスチャンピオン獲得。</li>' },
                    { id:1999, cap:'<li>世界選手権ロードレースをツインリンクもてぎに会場変更し開催</li>' },
                    { id:2000, cap:'<li>トライアル世界選手権を開催（ツインリンクもてぎ）。</li><li>世界選手権ロードレースを鈴鹿、もてぎを会場に年2回開催。</li><li>全日本モトクロス選手権でレディースクラス設定。</li>' },
                    { id:2001, cap:'<li>加藤大治郎ロードレース世界選手権ＧＰ250クラスチャンピオン獲得。スポーツ功労者顕彰を受ける。</li><li>ダートトラック全日本選手権開始（〜2003）。</li><li>レースを気軽に楽しむをモットーに「ストリートバイクゲームス」を開催。</li>' },
                    { id:2002, cap:'<li>全日本ロードレース選手権最高峰クラスチャンピオンに文部科学大臣杯の授与が始まる。</li><li>MFJオフロードバイクゲームスを開催。</li>' },
                    { id:2003, cap:'<li>MFJインストラクターセミナーを初開催、30名が出席。</li>' },
                    { id:2004, cap:'<li>藤波貴久、日本人初のトライアル世界選手権チャンピオンを獲得。スポーツ功労者顕彰を受ける。</li>' },
                    { id:2005, cap:'<li>スーパーモタード、エンデューロの全国格式競技会開始。</li><li>北川圭一、世界耐久選手権チャンピオン獲得。</li><li>モトクロス日本グランプリをスポーツランドSUGOで開催。（〜2007）</li>' },
                    { id:2006, cap:'<li>北川圭一、世界耐久選手権チャンピオン獲得。</li><li>ＭＦＪロードレースアカデミーを開校、若手ライダーの育成に努める。</li>' },
                    { id:2007, cap:'<li>全日本トライアルで若手育成をテーマにエキジビション125クラスを設定。</li><li>MFJトライアルアカデミーを開校、次世代の育成、トライアルの普及に努める。</li>' },
                    { id:2008, cap:'<li>MFJレディースロードレース大会開始。</li>' },
                    { id:2009, cap:'<li>青山博一、ロードレース世界選手権ＧＰ250クラスチャンピオン獲得。クラス最後のチャンピオンとなる。</li>' },
                    { id:2010, cap:'<li>2009年ロードレース世界選手権GP250クラスチャンピオンとして青山博一選手が文部科学省スポーツ功労者顕彰を受賞。</li>' },
                    { id:2011, cap:'<li>東日本大震災が発生し、全日本選手権は一部日程変更・中止等の影響を受け、同様に地方選手権も大きな影響を受けた。</li><li>全日本選手権ならびにMFJHPで東日本大震災復興支援の為、「がんばろう日本！」を合言葉に募金活動等チャリティイベントを実施</li><li>全日本ロードレース選手権にてライブ動画配信を開始</li><li>藤原克昭選手、FIMアジアロードレース選手権SS600にてチャンピオンを獲得</li><li>第1回MFJ親子バイク祭りを開催（ポケバイ・ミニバイクレースと体験走行）</li><li>全日本モトクロス選手権、成田 亮選手が第9戦にて100勝を達成</li>' },
                    { id:2012, cap:'<li>一般財団法人への移行登記を完了</li><li>情報発信の迅速化を目的に、会員への情報発信は機関誌『MFJライディング』から電子媒体のMFJオンラインマガジン(HP)へ移行した。</li><li>会員の利便性向上の為、MFJ会員登録申請をWEB上で行えるシステムの運用を開始</li><li>全日本トライアル選手権にて、黒山健一選手が全日本最高峰クラス史上最多の11回目のチャンピオンを獲得（当時）</li><li>※MFJが管轄する全日本選手権の最多記録を更新（当時）</li><li>FIMアジアロードレース選手権HONDA CBR250アジア・ドリーム・カップにて大久保 光選手がチャンピオン獲得</li>' },
                    { id:2013, cap:'<li>スーパーモタードのシリーズ呼称を「Moto1オールスターズ」から「全日本スーパーモタード選手権」とした。</li><li>全日本モトクロス選手権専用ファンサイトをMFJHP内に開設</li>' },
                    { id:2014, cap:'<li>施策決定の迅速化を図る目的で専門委員会の再編を実施</li><li>レース時のメディカルに関する事柄を検討するメディカル部会を設立</li><li>競技会申請/報告のWEBシステムを稼働</li>' },
                    { id:2015, cap:'<li>「走ろう東北！MFJ東北復興応援ツーリング」をスタート（2019年まで開催）。</li><li>19年ぶりにヤマハがファクトリー体制で鈴鹿8耐に出場、優勝を飾る</li><li>全日本ロードレース選手権ST600クラス、ワンメイクタイヤ制度を導入</li><li>神戸空港開港10周年記念として全日本モトクロス「スーパーモトクロスin神戸」を開催</li><li>全日本スノーモビル選手権B級S3クラスにおいて、笹岡千夏選手が女性として初めてチャンピオンを獲得</li>' },
                    { id:2016, cap:'<li>熊本地震の影響で九州地区の全日本選手権が中止/延期等の影響を受けた。HP並びに大会時に募金活動等実施</li><li>国別対抗戦のFIMトライアル・デ・ナシオンにて、日本代表チーム（藤波貴久、小川友幸、黒山健一）が世界2位を獲得</li><li>JP250クラスを設立。MFJカップJP250を全日本ロードレース選手権第1戦筑波大会で初開催</li><li>全日本ロードレース選手権JSB1000クラスで中須賀選手が最高峰クラスにおける5年連続チャンピオンで記録更新</li><li>全日本トライアル選手権にてレディースクラス開始。初代チャンピオンは西村亜矢選手が獲得</li><li>井形とも氏がFIMからレジェンドライダー表彰を授与された。</li>' },
                    { id:2017, cap:'<li>国別対抗戦のFIMトライアル・デ・ナシオンにて、日本代表チーム（藤波貴久、小川友幸、黒山健一）が世界3位を獲得</li>' },
                    { id:2018, cap:'<li>F.C.C TSR Hondaが2017-2018FIM EWC 世界耐久ロードレース選手権にて世界チャンピン獲得</li><li>MFJモーターサイクルスポーツ殿堂を設立。第1回は高橋国光氏・伊藤光夫氏が顕彰された</li><li>全日本モトクロス選手権IA-1にて成田 亮選手が150勝を達成</li><li>全日本モトクロス選手権IA-1にて成田 亮選手が優勝し、12度目のチャンピオンを獲得。全日本トライアルの黒山健一選手が持っていた最多勝利記録を更新する</li><li>国別対抗戦のFIMトライアル・デ・ナシオンにて、日本代表チーム（藤波貴久、小川友幸、黒山健一）が世界2位を獲得</li><li>FIMトライアル世界選手権Trial-Eクラス（電動）において、黒山健一選手が世界2位を獲得</li><li>ジムカーナ団体JAGEと連携し承認競技としてモトジムカーナグレートシリーズをツインリンクもてぎと岡山国際サーキットで初開催</li>' },
                    { id:2019, cap:'<li>カワサキのファクトリーチームが18年ぶりに鈴鹿8耐に参戦。26年ぶり2度目の優勝を果たした</li><li>2018年に続き、FIMトライアル世界選手権Trial-Eクラス（電動）において、黒山健一選手が世界2位を獲得</li><li>全日本モトクロス選手権第4戦SUGO大会にて、エキシビション2st125クラスを初開催</li><li>エンデューロ国別対抗戦・FIM ISDEに日本代表チームが参戦し、E2クラスに出場した釘村 忠選手が日本人初のゴールドメダルを獲得</li><li>全日本ロードレース選手権J-GP2クラスが終了</li><li>MFJモーターサイクルスポーツ殿堂で本田宗一郎氏並びに吉村秀雄氏を顕彰</li><li>全日本モトクロス選手権全戦の動画ライブ配信を開始</li>' },
                    { id:2020, cap:'<li>新型コロナウイルス感染症の拡大で、全日本をはじめ世界選手権など多くのレースが延期や中止となる</li><li>全日本ロードレース選手権にて、ST1000クラスがスタート</li><li>全日本モトクロス選手権第3戦SUGO大会のIA-1クラスで決勝3ヒート制を採用</li><li>ランキング表彰式MFJ MOTO AWARDS SHOWを初のオンラインで開催</li>' },
                    { id:2021, cap:'<li>新型コロナウイルス感染は終息せず、全日本、世界選手権など多くのレースが延期や中止となる。</li><li>地区管理を8地区加盟団体（日本二輪車普及安全協会へ業務委託）からMFJ本部主導の広域事務局に移管</li><li>全日本モトクロス選手権・トライアル選手権のシリーズ管理業務を外部委託開始</li><li>全日本モトクロス選手権に初めてシリーズ冠協賛を得る。</li><li>4月よりMFJHP全面リニューアル。</li>' },
                ]
            }
        },
        computed: {
       limitCount60() {
        return this.childs.slice(0,10)
       },
       limitCount70() {
        return this.childs.slice(10,20)
       },
       limitCount80() {
        return this.childs.slice(20,30)
       },
       limitCount90() {
        return this.childs.slice(30,40)
       },
       limitCount00() {
        return this.childs.slice(40,50)
       },
       limitCount10() {
        return this.childs.slice(50,61)
       },
      },
        components: {
            'yearBox' : yearBox
        },
        methods: { 
            defaultShow: function () {
                var result = '',
                    selected = 1963;
                items.forEach(function(item) {
                    if(item.year == selected){
                    var src = item.year+'_'+item.no+'_'+item.global;
                    result += '<li><a target="_blank" href="../pdfviewer/web/viewer.html?file=/pdf/'+src+'.pdf"><img src="/cover/'+item.year+'/'+src+'.jpg" width="120" height="175"></a></li>';
                    }
                    
                });
                document.querySelector(".currentBook").insertAdjacentHTML('afterbegin', result);
            },
            defaultShow2: function () {
                var result = '',
                    selected = 1978;
                items.forEach(function(item) {
                    if(item.year == selected){
                    var src = item.year+'_'+item.no+'_'+item.global;
                    result += '<li><a target="_blank" href="../pdfviewer/web/viewer.html?file=/pdf/'+src+'.pdf"><img src="/cover/'+item.year+'/'+src+'.jpg" width="120" height="175"></a></li>';
                    }
                    
                });
                document.querySelector(".currentBook2").insertAdjacentHTML('afterbegin', result);
            },
            defaultShow3: function () {
                var result = '',
                    selected = 1985;
                items.forEach(function(item) {
                    if(item.year == selected){
                    var src = item.year+'_'+item.no+'_'+item.global;
                    result += '<li><a target="_blank" href="../pdfviewer/web/viewer.html?file=/pdf/'+src+'.pdf"><img src="/cover/'+item.year+'/'+src+'.jpg" width="120" height="175"></a></li>';
                    }
                    
                });
                document.querySelector(".currentBook3").insertAdjacentHTML('afterbegin', result);
            },
            defaultShow4: function () {
                var result = '',
                    selected = 1994;
                items.forEach(function(item) {
                    if(item.year == selected){
                    var src = item.year+'_'+item.no+'_'+item.global;
                    result += '<li><a target="_blank" href="../pdfviewer/web/viewer.html?file=/pdf/'+src+'.pdf"><img src="/cover/'+item.year+'/'+src+'.jpg" width="120" height="175"></a></li>';
                    }
                    
                });
                document.querySelector(".currentBook4").insertAdjacentHTML('afterbegin', result);
            },
            defaultShow5: function () {
                var result = '',
                    selected = 2001;
                items.forEach(function(item) {
                    if(item.year == selected){
                    var src = item.year+'_'+item.no+'_'+item.global;
                    result += '<li><a target="_blank" href="../pdfviewer/web/viewer.html?file=/pdf/'+src+'.pdf"><img src="/cover/'+item.year+'/'+src+'.jpg" width="120" height="175"></a></li>';
                    }
                    
                });
                document.querySelector(".currentBook5").insertAdjacentHTML('afterbegin', result);
            },
            defaultShow6: function () {
                var result = '',
                    selected = 2012;
                items.forEach(function(item) {
                    if(item.year == selected){
                    var src = item.year+'_'+item.no+'_'+item.global;
                    result += '<li><a target="_blank" href="../pdfviewer/web/viewer.html?file=/pdf/'+src+'.pdf"><img src="/cover/'+item.year+'/'+src+'.jpg" width="120" height="175"></a></li>';
                    }
                    
                });
                document.querySelector(".currentBook6").insertAdjacentHTML('afterbegin', result);
            },
            loading: function () {
                const loader = document.getElementById('js-loader');
                  const ms = 400;
                  loader.style.transition = 'opacity ' + ms + 'ms';
                  
                  const loaderOpacity = function(){
                    loader.style.opacity = 0;
                  }
                  const loaderDisplay = function(){
                    loader.style.display = "none";
                  }
                  setTimeout(loaderOpacity, 3000);
                  setTimeout(loaderDisplay, 3000 + ms);
            },
        },
        mounted : function(){
            var routeInstance = this.$route;
            this.defaultShow(routeInstance);
            this.defaultShow2(routeInstance);
            this.defaultShow3(routeInstance);
            this.defaultShow4(routeInstance);
            this.defaultShow5(routeInstance);
            this.defaultShow6(routeInstance);
            this.loading(routeInstance);
        },
        watch: { 
          '$route' (routeInstance) {
              this.defaultShow(routeInstance);
          }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">
.history{
    display: flex;
    justify-content: space-between;
    &__head{
        cursor: pointer;
        width: 140px;
        border: none;
        background: transparent;
        padding: 0;
        display: flex;
        align-items: flex-start;
        position: relative;
        padding-bottom: 30px;
        &:after{
            content:"";
            display: block;
            width: 5px;
            height: 100%;
            background: #cb0510;
            position: absolute;
            top: 0;
            left: calc(50% - 2.5px);
            
        }
        &--circle {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 140px;
            height: 140px;
            border-radius: 50%;
            background: #cb0510;
            color: #fff;
            font-weight: bold;
            font-family: "Barlow Condensed", sans-serif;
            font-size: 30px;
            letter-spacing: 2px;
            position: relative;
            z-index: 1;
        }
    }
    &__content{
        width: calc(100% - 170px);
        &--box{
            margin-bottom: 30px;
        }
    }
}
.wrap .history:last-child{
    .history__head{
        padding: 0;
    }
}
.year-list{
    &__trigger{
        background: #fff;
        cursor: pointer;
        width: 320px;
        max-width: 100%;
        border: none;
        text-align: left;
        padding: 20px;
        font-family: serif;
        font-size: 25px;
        position: relative;
        font-weight: bold;
        &:before{
            color: #cb0510;
            position: absolute;
            content: "+";
            font-size: 2em;
            line-height: 1;
            display: block;
            top: 10px;
            right: 20px;
            transition: 0.5s;
        }
        &--sub{
            font-size: 0.6em;
            opacity: .4;
            display: inline-block;
            margin-left: 10px;
            font-family: "Helvetica Neue", Arial,"Hiragino Kaku Gothic ProN","Hiragino Sans",Meiryo,sans-serif;
        }
        &.active{
            width: 100%;
            &:before{
                content: "-";
                transform: scaleX(2);
            }
        }
    }
    &__content{
        background: #fff;
        padding: 10px 20px;
        position: relative;
        z-index: 1;
        &--text{
            margin: -10px 0 0;
            padding-left: 30px;
        }
        &--title{
            font-family: 'Barlow Condensed', sans-serif;
            font-size: 20px;
            margin: 20px 0 0;
            display: flex;
            align-items: center;
            svg{
                margin: 0 10px 0 0;
            }
        }
    }
}
.lookBook{
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0;
    padding: 0;
    li{
        margin: 0 20px 20px 0;
    }
    a{
        display: block;
    }
    img{
        display: block;
        box-shadow: 10px 10px 10px -5px #aaa;
    }
}
.loader {
  align-items: center;
  background: #000;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 999;
  img{
    position: absolute;
    top: calc(50% - 75px);
    left: calc(50% - 90px);
  }
  &__01{
      opacity : 0;
      animation: fadeIn 2s ease 0s 1 forwards;
  }
  &__02{
      opacity : 0;
      animation: fadeIn2 2s ease 0.6s 1 forwards;
  }
  &__03{
      opacity : 0;
      animation: fadeIn 2s ease 1.2s 1 forwards;
  }
  
}

@keyframes fadeIn {
  0% {opacity: 0}
  100% {opacity: 1}
}
@keyframes fadeIn2 {
  0% {
      opacity: 0;
      transform: translateY(50px);
  }
  100% { 
      opacity: 1;
      transform: translateY(0);
  }
}

@media(max-width:767px){
    .history{
        &__head{
            width: 70px;
            &--circle{
                width: 70px;
                height: 70px;
                font-size: 18px;
            }
        }
        &__content {
            width: calc(100% - 80px);
        }
    }
    .year-list{
        &__trigger{
            font-size: 18px;
            margin-bottom: -5px;
        }
    }
    .lookBook{
        li{
            margin: 0 10px 15px;
        }
        img{
            width: 72px;
        }
    }
    .year-list__content--text {
        padding-left: 1em;
    }
}

</style>